import React, { PureComponent } from 'react'
import { Outlet } from 'react-router-dom'
import { DsBox } from '@am92/react-design-system'

import OfflineOverlay from '../../Components/OfflineOverlay'
import Header from '../Components/Header'
import FcmNotification from '~/src/Components/Fcm/FcmNotification'

interface IAdminAuthenticatedLayoutProps {}

class AdminAuthenticatedLayout extends PureComponent<IAdminAuthenticatedLayoutProps> {
  render() {
    return (
      <DsBox
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'var(--vh)', // TODO: Solve for web and cordova
          overflow: 'auto'
          // scrollbarWidth: 'none',
          // '&::-webkit-scrollbar': {
          //   display: 'none'
          // }
        }}
      >
        <OfflineOverlay />
        <FcmNotification />
        <Header />
        <Outlet />
      </DsBox>
    )
  }
}

export default AdminAuthenticatedLayout
